module.exports = __webpack_public_path__ + "img/right_md_4.482e0eaa.jpg";